<template>
    <div class="vc-checkout-header">
        <span class="vc-checkout-header__title">ORDER SUMMARY</span>
        <span class="vc-checkout-header__toggle" @click="toggle()">
              <span class="vc-checkout-header__toggle__label">{{countCartItems}} Items</span>
              <span :class="{'c-accordion-toggle--active': active}"
                    class="c-accordion-toggle">
                  <font-awesome-icon icon="chevron-down"></font-awesome-icon>
              </span>
        </span>
    </div>
</template>

<script>
    export default {
        name: "checkout-header",
        data() {
            return {
                active: true,
            }
        },
        computed: {
            countCartItems() {
                return this.$store.state.cart.cart.length;
            },
            cart() {
                return this.$store.state.cart;
            }
        },
        methods: {
            toggle() {
                this.active = !this.active;
                this.$emit('toggle', this.active);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .vc-checkout-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;

        &__title {
            color: var(--highlight-color);
            font-size: 20px;
        }

        &__toggle {
            display: flex;
            align-items: center;

            &__label {
                margin-right: 0.6rem;
                color: var(--highlight-color);
                font-size: 14px;
            }
        }
    }
</style>